import { ArrowRight } from 'lucide-react';
import { routeToIntake } from '../lib/intakeRouting';

// Ratified footer treatment (Visual Contract §10.7): gradient wordmark + gradient CTA.
// Copy adjusted away from generic website-studio positioning ("A Site to Behold") to
// the proof-to-presence promise. No unsupported metrics or invented case studies.
export function Footer() {
  return (
    <footer className="border-t border-white/10 bg-obsidian text-chalk">
      <div className="mx-auto w-full max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="text-4xl font-black leading-tight tracking-tight sm:text-5xl">
            Seen to be believed.
          </h2>
          <p className="mt-5 text-lg leading-8 text-ash">
            Macellum turns your business proof into visible, citable, sales-ready market presence.
            Send proof once — review the drafts — approve what goes live.
          </p>

          <div className="mt-9 flex flex-col justify-center gap-3 sm:flex-row">
            <button
              type="button"
              onClick={() => routeToIntake({ intent: 'm2m', productHint: 'm2m_t1' })}
              className="inline-flex h-12 items-center justify-center gap-2 px-7 text-sm font-black uppercase tracking-wide text-obsidian transition hover:opacity-90"
              style={{ backgroundImage: 'linear-gradient(to right, #18D6FF 0%, #6E4DFF 50%, #D4A017 100%)' }}
            >
              Turn proof into presence
              <ArrowRight className="size-5" aria-hidden="true" />
            </button>
            <button
              type="button"
              onClick={() => routeToIntake({ intent: 'aeo', productHint: 'aeo_t1' })}
              className="inline-flex h-12 items-center justify-center gap-2 border border-white/20 px-7 text-sm font-black uppercase tracking-wide text-chalk transition hover:border-cyan hover:text-cyan"
            >
              Repair my AI visibility
            </button>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-center justify-between gap-6 border-t border-white/10 pt-8 md:flex-row">
          <span className="text-3xl font-black tracking-tight text-wordmark">MACELLUM</span>
          <p className="text-center text-sm text-ash md:text-right">
            A SIDOM MEDIA LTD venture, part of the SIDOM venture mesh.
            <br className="hidden md:block" />
            &copy; {new Date().getFullYear()} Macellum. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
